export const en = [
  { _id: 'a-little-queens-huge-crown', name: "A Little Queen's Huge Crown", rarity: 5, role: 'warrior' },
  { _id: 'abyssal-crown', name: 'Abyssal Crown', rarity: 5, role: 'mage' },
  { _id: 'airtosurface-missile-misha', name: 'Air-to-Surface Missile: MISHA', rarity: 5, role: 'ranger' },
  { _id: 'alabastron', name: 'Alabastron', rarity: 5, role: 'assassin' },
  { _id: 'alencinoxs-wrath', name: "Alencinox's Wrath", rarity: 5, role: 'warrior' },
  { _id: 'alexas-basket', name: "Alexa's Basket", rarity: 5, role: 'assassin' },
  { _id: 'ancient-dragons-legacy', name: "Ancient Dragon's Legacy", rarity: 5, role: 'knight' },
  { _id: 'bastion-of-perlutia', name: 'Bastion of Perlutia', rarity: 5, role: 'knight' },
  { _id: 'black-hand-of-the-goddess', name: 'Black Hand of the Goddess', rarity: 5, role: 'mage' },
  { _id: 'bloodseared-moon', name: 'Blood-Seared Moon', rarity: 5, role: '' },
  { _id: 'bloodstone', name: 'Bloodstone', rarity: 5, role: 'ranger' },
  { _id: 'bloody-rose', name: 'Bloody Rose', rarity: 5, role: 'mage' },
  { _id: 'border-coin', name: 'Border Coin', rarity: 5, role: 'warrior' },
  { _id: 'celestine', name: 'Celestine', rarity: 5, role: 'manauser' },
  { _id: 'champions-trophy', name: "Champion's Trophy", rarity: 5, role: 'warrior' },
  { _id: 'chatty', name: 'Chatty', rarity: 5, role: 'mage' },
  { _id: 'circus-fantasia', name: 'Circus Fantasia', rarity: 5, role: 'warrior' },
  { _id: 'cradle-of-life', name: 'Cradle of Life', rarity: 5, role: 'warrior' },
  { _id: 'creation-destruction', name: 'Creation & Destruction', rarity: 5, role: 'warrior' },
  { _id: 'crimson-moon-of-nightmares', name: 'Crimson Moon of Nightmares', rarity: 5, role: 'mage' },
  { _id: 'crown-of-glory', name: 'Crown of Glory', rarity: 5, role: 'knight' },
  { _id: 'cruel-mischief', name: 'Cruel Mischief', rarity: 5, role: '' },
  { _id: 'dignus-orb', name: 'Dignus Orb', rarity: 5, role: 'mage' },
  { _id: 'doctors-bag', name: "Doctor's Bag", rarity: 5, role: 'manauser' },
  { _id: 'doubleedged-decrescent', name: 'Double-Edged Decrescent', rarity: 5, role: 'assassin' },
  { _id: 'draco-plate', name: 'Draco Plate', rarity: 5, role: 'warrior' },
  { _id: 'durandal', name: 'Durandal', rarity: 5, role: 'warrior' },
  { _id: 'dux-noctis', name: 'Dux Noctis', rarity: 5, role: 'ranger' },
  { _id: 'elbris-ritual-sword', name: 'Elbris Ritual Sword', rarity: 5, role: 'knight' },
  { _id: 'eticas-scepter', name: "Etica's Scepter", rarity: 5, role: 'mage' },
  { _id: 'fairy-tale-for-a-nightmare', name: 'Fairy Tale for a Nightmare', rarity: 5, role: 'mage' },
  { _id: 'guiding-light', name: 'Guiding Light', rarity: 5, role: 'ranger' },
  { _id: 'holy-sacrifice', name: 'Holy Sacrifice', rarity: 5, role: 'knight' },
  { _id: 'idols-cheer', name: "Idol's Cheer", rarity: 5, role: 'manauser' },
  { _id: 'iron-fan', name: 'Iron Fan', rarity: 5, role: 'ranger' },
  { _id: 'junkyard-dog', name: 'Junkyard Dog', rarity: 5, role: 'warrior' },
  { _id: 'justice-for-all', name: 'Justice for All', rarity: 5, role: 'knight' },
  { _id: 'knowledge-seed', name: 'Knowledge Seed', rarity: 5, role: 'mage' },
  { _id: 'last-teatime', name: 'Last Teatime', rarity: 5, role: 'mage' },
  { _id: 'manica-of-control', name: 'Manica of Control', rarity: 5, role: 'assassin' },
  { _id: 'manifu', name: 'Manifu', rarity: 5, role: '' },
  { _id: 'merciless-glutton', name: 'Merciless Glutton', rarity: 5, role: 'warrior' },
  { _id: 'ms-confille', name: 'Ms. Confille', rarity: 5, role: 'ranger' },
  { _id: 'necro-undine', name: 'Necro & Undine', rarity: 5, role: 'mage' },
  { _id: 'noble-oath', name: 'Noble Oath', rarity: 5, role: 'knight' },
  { _id: 'otherworldly-machinery', name: 'Otherworldly Machinery', rarity: 5, role: 'ranger' },
  { _id: 'proof-of-valor', name: 'Proof of Valor', rarity: 5, role: '' },
  { _id: 'reingars-special-drink', name: "Reingar's Special Drink", rarity: 5, role: 'ranger' },
  { _id: 'rhianna-luciella', name: 'Rhianna & Luciella', rarity: 5, role: 'assassin' },
  { _id: 'rise-of-a-monarch', name: 'Rise of a Monarch', rarity: 5, role: 'knight' },
  { _id: 'rod-of-amaryllis', name: 'Rod of Amaryllis', rarity: 5, role: 'manauser' },
  { _id: 'samsara-prayer-beads', name: 'Samsara Prayer Beads', rarity: 5, role: 'warrior' },
  { _id: 'secret-art-storm-sword', name: 'Secret Art - Storm Sword', rarity: 5, role: 'assassin' },
  { _id: 'shepherd-of-the-hollow', name: 'Shepherd of the Hollow', rarity: 5, role: 'assassin' },
  { _id: 'shimadra-staff', name: 'Shimadra Staff', rarity: 5, role: 'manauser' },
  { _id: 'sigurd-scythe', name: 'Sigurd Scythe', rarity: 5, role: 'warrior' },
  { _id: 'snow-crystal', name: 'Snow Crystal', rarity: 5, role: 'warrior' },
  { _id: 'song-of-stars', name: 'Song of Stars', rarity: 5, role: 'ranger' },
  { _id: 'spear-of-a-new-dawn', name: 'Spear of a New Dawn', rarity: 5, role: 'knight' },
  { _id: 'spirits-breath', name: "Spirit's Breath", rarity: 5, role: 'mage' },
  { _id: 'star-piercer', name: 'War Horn', rarity: 5, role: '' },
  { _id: 'stella-harpa', name: 'Stella Harpa', rarity: 5, role: 'manauser' },
  { _id: 'sword-of-ezera', name: 'Sword of Ezera', rarity: 5, role: 'knight' },
  { _id: 'sword-of-holy-light', name: 'Sword of Holy Light', rarity: 5, role: '' },
  { _id: 'sword-of-judgment', name: 'Sword of Judgment', rarity: 5, role: 'ranger' },
  { _id: 'sword-of-summer-twilight', name: 'Sword of Summer Twilight', rarity: 5, role: 'assassin' },
  { _id: 'time-matter', name: 'Time Matter', rarity: 5, role: 'mage' },
  { _id: 'torn-sleeve', name: 'Torn Sleeve', rarity: 5, role: 'assassin' },
  { _id: 'touch-of-rekos', name: 'Touch of Rekos', rarity: 5, role: 'manauser' },
  { _id: 'twilight-calamity', name: 'Twilight Calamity', rarity: 5, role: 'mage' },
  { _id: 'uberiuss-tooth', name: "Uberius's Tooth", rarity: 5, role: 'warrior' },
  { _id: 'unfading-memories', name: 'Unfading Memories', rarity: 5, role: 'manauser' },
  { _id: 'unseen-observer', name: 'Unseen Observer', rarity: 5, role: 'ranger' },
  { _id: 'violet-talisman', name: 'Violet Talisman', rarity: 5, role: 'assassin' },
  { _id: 'wall-of-order', name: 'Wall of Order', rarity: 5, role: 'ranger' },
  { _id: 'war-horn', name: 'War Horn', rarity: 5, role: '' },
  { _id: 'wind-rider', name: 'Wind Rider', rarity: 5, role: 'assassin' },
  { _id: 'adamant-shield', name: 'Adamant Shield', rarity: 4, role: 'knight' },
  { _id: 'ambrote', name: 'Ambrote', rarity: 4, role: 'ranger' },
  { _id: 'andres-crossbow', name: "Andre's Crossbow", rarity: 4, role: 'ranger' },
  { _id: 'aurius', name: 'Aurius', rarity: 4, role: 'knight' },
  { _id: 'barthezs-orbuculum', name: "Barthez's Orbuculum", rarity: 4, role: 'mage' },
  { _id: 'bloody-warhammer', name: 'Bloody Warhammer', rarity: 4, role: '' },
  { _id: 'card-of-small-miracles', name: 'Card of Small Miracles', rarity: 4, role: '' },
  { _id: 'celestial-spear', name: 'Celestial Spear', rarity: 4, role: '' },
  { _id: 'crimson-seed', name: 'Crimson Seed', rarity: 4, role: 'warrior' },
  { _id: 'dust-devil', name: 'Dust Devil', rarity: 4, role: 'assassin' },
  { _id: 'els-fist', name: "El's Fist", rarity: 4, role: 'warrior' },
  { _id: 'elyhas-knife', name: "Elyha's Knife", rarity: 4, role: 'assassin' },
  { _id: 'eternus', name: 'Eternus', rarity: 4, role: 'manauser' },
  { _id: 'flower-shower', name: 'Flower Shower', rarity: 4, role: 'warrior' },
  { _id: 'golden-cocoa-cookie', name: 'Golden Cocoa Cookie', rarity: 4, role: '' },
  { _id: 'hell-cutter', name: 'Hell Cutter', rarity: 4, role: 'warrior' },
  { _id: 'hilag-lance', name: 'Hilag Lance', rarity: 4, role: 'knight' },
  { _id: 'iela-violin', name: 'Iela Violin', rarity: 4, role: 'mage' },
  { _id: 'infinity-basket', name: 'Infinity Basket', rarity: 4, role: 'ranger' },
  { _id: 'kaladra', name: "Kal'adra", rarity: 4, role: 'mage' },
  { _id: 'love-potion', name: 'Love Potion', rarity: 4, role: '' },
  { _id: 'magarahas-tome', name: "Magaraha's Tome", rarity: 4, role: 'manauser' },
  { _id: 'midnight-bloom', name: 'Midnight Bloom', rarity: 4, role: '' },
  { _id: 'moonlight-dreamblade', name: 'Moonlight Dreamblade', rarity: 4, role: 'assassin' },
  { _id: 'new-year-cookies', name: 'New Year Cookies', rarity: 4, role: '' },
  { _id: 'one-year-of-gratitude', name: 'One Year of Gratitude', rarity: 4, role: '' },
  { _id: 'portrait-of-the-saviors', name: 'Portrait of the Saviors', rarity: 4, role: '' },
  { _id: 'radiant-forever', name: 'Radiant Forever', rarity: 4, role: 'mage' },
  { _id: 'rainbow-scale', name: 'Rainbow Scale', rarity: 4, role: '' },
  { _id: 'rosa-hargana', name: 'Rosa Hargana', rarity: 4, role: 'ranger' },
  { _id: 'santa-muerte', name: 'Santa Muerte', rarity: 4, role: 'assassin' },
  { _id: 'sashe-ithanes', name: 'Sashe Ithanes', rarity: 4, role: 'ranger' },
  { _id: 'sepulcrum', name: 'Sepulcrum', rarity: 4, role: 'warrior' },
  { _id: 'shepherds-of-chaos', name: 'Shepherds of Chaos', rarity: 4, role: 'assassin' },
  { _id: 'silver-rain', name: 'Silver Rain', rarity: 4, role: 'assassin' },
  { _id: 'siraren', name: 'Sira-Ren', rarity: 4, role: 'mage' },
  { _id: 'spooky-solayu-stories', name: 'Spooky Solayu Stories', rarity: 4, role: '' },
  { _id: 'steadfast-gatekeeper', name: 'Steadfast Gatekeeper', rarity: 4, role: 'knight' },
  { _id: 'strak-gauntlet', name: 'Strak Gauntlet', rarity: 4, role: 'warrior' },
  { _id: 'succubus-mirror', name: 'Succubus Mirror', rarity: 4, role: '' },
  { _id: 'tagehels-ancient-book', name: "Tagehel's Ancient Book", rarity: 4, role: 'mage' },
  { _id: 'tear-of-the-desert', name: 'Tear of the Desert', rarity: 4, role: 'mage' },
  { _id: 'to-a-new-world', name: 'To a New World', rarity: 4, role: '' },
  { _id: 'waters-origin', name: "Water's Origin", rarity: 4, role: 'manauser' },
  { _id: 'wondrous-potion-vial', name: 'Wondrous Potion Vial', rarity: 4, role: 'manauser' },
  { _id: 'xvi-the-tower', name: 'XVI. The Tower', rarity: 4, role: '' },
  { _id: 'alsacian-spear', name: 'Alsacian Spear', rarity: 3, role: '' },
  { _id: 'ancient-sheath', name: 'Ancient Sheath', rarity: 3, role: '' },
  { _id: 'aqua-rose', name: 'Aqua Rose', rarity: 3, role: '' },
  { _id: 'ascending-axe', name: 'Ascending Axe', rarity: 3, role: '' },
  { _id: 'atmas-portal', name: "Atma's Portal", rarity: 3, role: '' },
  { _id: 'butterfly-mandolin', name: 'Butterfly Mandolin', rarity: 3, role: '' },
  { _id: 'cursed-compass', name: 'Cursed Compass', rarity: 3, role: '' },
  { _id: 'daydream-joker', name: 'Daydream Joker', rarity: 3, role: '' },
  { _id: 'devils-brand', name: "Devil's Brand", rarity: 3, role: '' },
  { _id: 'egg-of-delusion', name: 'Egg of Delusion', rarity: 3, role: '' },
  { _id: 'envoys-pipe', name: "Envoy's Pipe", rarity: 3, role: '' },
  { _id: 'exorcists-tonfa', name: "Exorcist's Tonfa", rarity: 3, role: '' },
  { _id: 'forest-totem', name: 'Forest Totem', rarity: 3, role: '' },
  { _id: 'goblins-lamp', name: "Goblin's Lamp", rarity: 3, role: '' },
  { _id: 'grail-of-blood', name: 'Grail of Blood', rarity: 3, role: '' },
  { _id: 'labyrinth-cube', name: 'Labyrinth Cube', rarity: 3, role: '' },
  { _id: 'mighty-yaksha', name: 'Mighty Yaksha', rarity: 3, role: '' },
  { _id: 'oath-key', name: 'Oath Key', rarity: 3, role: '' },
  { _id: 'prophetic-candlestick', name: 'Prophetic Candlestick', rarity: 3, role: '' },
  { _id: 'ranons-memorandum', name: "Ranon's Memorandum", rarity: 3, role: '' },
  { _id: 'ruby-essence', name: 'Ruby Essence', rarity: 3, role: '' },
  { _id: 'sword-of-the-morning', name: 'Sword of the Morning', rarity: 3, role: '' },
  { _id: 'timeless-anchor', name: 'Timeless Anchor', rarity: 3, role: '' },
];
